import { useEffect, useRef } from 'react';
import cn from 'classnames';
import styles from './uploadFile.module.scss';
import { useTranslation } from 'react-i18next';

interface UploadFileProps {
  onChange: (file: File) => void;
  className?: string;
  selectedFile: File | null;
}

const UploadFile = ({ selectedFile, onChange, className }: UploadFileProps) => {
  const filePicker = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files === null) return;
    onChange(e.target.files[0]);
  };

  const handlePick = () => {
    if (filePicker.current !== null) {
      filePicker.current.click();
    }
  };

  useEffect(() => {
    if (selectedFile) return;

    if (filePicker.current === null) return;
    filePicker.current.value = '';
  }, [selectedFile]);

  return (
    <>
      <div className={styles.upload}>
        <input
          type="file"
          onChange={handleChange}
          accept=".csv, .xls, .xlsx"
          className={cn(styles.uploadInput, className)}
          ref={filePicker}
        />
        <button onClick={handlePick} className={styles.uploadBtn}>
          {!selectedFile ? (
            <span>{t('choose_file')}</span>
          ) : (
            <span>{t('upload_success')}</span>
          )}
        </button>
      </div>
    </>
  );
};

export default UploadFile;
